import React, { useEffect } from "react";
import { TextField } from "@material-ui/core";
import { Autocomplete as MuiAutocomplete } from "@material-ui/lab";
import { makeStyles, Checkbox } from "@material-ui/core";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { uniqBy } from "lodash";

const useStyles = makeStyles({
  tag: {
    backgroundColor: "rgb(232, 245, 225)",
    color: "black",
  },
  root: {
    zIndex: 0,
  },
});

const filterOptions = createFilterOptions({
  limit: 70,
});

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const AutocompleteMultiple = ({
  options = [],
  tip,
  placeholder = "Select option",
  loading,
  setValue,
  name,
  defaultValue,
  defaultValueField = "id",
  disabled,
  label = "label",
  disableCloseOnSelect = true,
  variant = "outlined",
  size = "medium",
  disableClearable = false,
  ...other
}) => {
  const classes = useStyles();

  const sortHelper = function(a, b) {
    if (a[label] > b[label]) return 1;
    if (a[label] < b[label]) return -1;
    return 0;
  };

  const handleChange = (_, value = []) => {
    setValue(
      name,
      value.map(({ value }) => value)
    );
  };

  const setDefaultValue = () =>
    options.filter((item) =>
      (defaultValue || []).includes(item[defaultValueField])
    );

  useEffect(() => {
    if (!defaultValue || !setValue) return;
    setValue(
      name,
      (setDefaultValue() || []).map(({ value }) => value)
    );
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <MuiAutocomplete
        options={uniqBy(options, label).sort(sortHelper)}
        filterOptions={filterOptions}
        id={name}
        onChange={handleChange}
        getOptionLabel={(item) => item[label]}
        defaultValue={setDefaultValue}
        disabled={disabled}
        multiple={true}
        disableCloseOnSelect={disableCloseOnSelect}
        classes={classes}
        disableClearable={disableClearable}
        renderInput={(params) => (
          <TextField
            {...params}
            label={placeholder}
            color="secondary"
            variant={variant}
            className={classes.root}
            size={size}
          />
        )}
        renderOption={(option, { selected }) => (
          <React.Fragment>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option[label]}
          </React.Fragment>
        )}
        {...other}
      />
      {tip && <div>{tip}</div>}
    </div>
  );
};
